import { render } from "./bounty.vue?vue&type=template&id=6f67afec&scoped=true"
import script from "./bounty.vue?vue&type=script&lang=js"
export * from "./bounty.vue?vue&type=script&lang=js"

import "./bounty.vue?vue&type=style&index=0&id=6f67afec&lang=scss&scoped=true"
import "./bounty.vue?vue&type=style&index=1&id=6f67afec&lang=scss"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f67afec"]])

export default __exports__